import { useAuth } from "@/utils/authentication";
import type { RouteLocationNormalized } from "vue-router";

export const authenticationGuard = async (to: RouteLocationNormalized) => {
  if (to.matched.some((record) => record.meta.public === true)) return true;
  const auth = useAuth();
  if (auth.status.value === "initializing") await auth.initialize();
  if (auth.isAuthenticated.value) return true;
  if (auth.status.value === "signedOut") {
    return { name: "Login", query: { redirect: to.fullPath } };
  }
  return { name: "Home" };
};
